// This module just returns the embedded data from the global namespace
// for other base modules to use
'use strict';

var root = require('./root').window;

// return a copy of the __hudlEmbed object, not a pointer to it
// TODO: eventually this should just return an immutable map
module.exports = JSON.parse(JSON.stringify(root.__hudlEmbed || {}));
